import { cn } from '@/lib/utils'
import type { Prioridad } from '@/mock'

interface PriorityChipProps {
  prioridad: Prioridad
  withLabel?: boolean
  className?: string
}

const config: Record<Prioridad, { color: string; label: string }> = {
  P1: { color: 'bg-rose-100 text-rose-700', label: 'Crítica' },
  P2: { color: 'bg-amber-100 text-amber-700', label: 'Alta' },
  P3: { color: 'bg-yellow-100 text-yellow-700', label: 'Media' },
  P4: { color: 'bg-blue-100 text-blue-700', label: 'Baja' },
  P5: { color: 'bg-slate-100 text-slate-600', label: 'Info' },
}

export function PriorityChip({ prioridad, withLabel, className }: PriorityChipProps) {
  const c = config[prioridad]
  return (
    <span className={cn('chip font-mono', c.color, className)}>
      {prioridad}
      {withLabel && <span className="font-sans ml-1">· {c.label}</span>}
    </span>
  )
}
